module.exports = {"141181001":"新义街道","141181002":"中阳楼街道","141181003":"振兴街道","141181004":"胜溪湖街道","141181005":"崇文街道","141181100":"兑镇镇","141181101":"阳泉曲镇","141181102":"下堡镇","141181103":"西辛庄镇","141181104":"高阳镇","141181105":"梧桐镇","141181106":"柱濮镇","141181107":"大孝堡镇","141181201":"下栅乡","141181202":"驿马乡","141181204":"杜村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141181.json
// module id = 477
// module chunks = 0